import { Component } from '@angular/core';
import { ProductListComponent } from '../product-list/product-list.component';
import { BennerComponent } from '../benner/benner.component';
import { AfterViewInit } from '@angular/core';
import { CategoryListComponent } from '../category-list/category-list.component';
import { CommonModule } from '@angular/common';
import { WebService } from '../../../core/services/web-service/web.service';
declare var $: any;
@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    ProductListComponent,
    BennerComponent,
    CategoryListComponent,
    CategoryListComponent,
    CommonModule,
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent {
  bannerList: any[] = [];
  categoryList: any[] = [];
  isSliderInitialized = false;
  bannerNullResponse = true;
  categoryNullResponse = true;

  constructor(private WebService: WebService) {}
  ngOnInit() {
    this.WebService.bannerDatalist$.subscribe((data) => {
      if (data?.status === 200) {
        this.bannerList = data?.data;
      } else {
        this.bannerList = [];
      }
    });
    this.WebService.bannerNullResponse$.subscribe((data) => {
      this.bannerNullResponse = data;
    });
    this.WebService.categoryNullResponse$.subscribe((data) => {
      this.categoryNullResponse = data;
    });
    this.WebService.categoryDatalist$.subscribe((data) => {
      if (data?.status === 200) {
        this.categoryList = data?.data;
        this.initializeSlick();
      } else {
        this.categoryList = [];
      }
    });
  }
  ngAfterViewInit(): void {
    $('.three-slider').slick({
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      arrows: false,
    });
  }
  ngAfterViewChecked(): void {
    if (!this.isSliderInitialized && this.categoryList.length > 0) {
      this.initializeSlick();
    }
  }
  initializeSlick(): void {
    setTimeout(() => {
      $('.category-slider').not('.slick-initialized').slick({
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 6,
        slidesToScroll: 6,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: true,
        responsive: [{
          breakpoint: 1745,
          settings: {
              slidesToShow: 7,
          }
      },
      {
          breakpoint: 1399,
          settings: {
              slidesToShow: 6,
          }
      },
      {
          breakpoint: 1124,
          settings: {
              slidesToShow: 5,
          }
      },
      {
          breakpoint: 900,
          settings: {
              slidesToShow: 4,
          }
      },
      {
          breakpoint: 692,
          settings: {
              slidesToShow: 3,
          }
      }, {
          breakpoint: 482,
          settings: {
              slidesToShow: 3,
          }
      },
  ]
      });
      this.isSliderInitialized = true;
    });
  }
}
